import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VerificationService } from '../_services/verification.service';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, ValidationErrors } from '@angular/forms';
import { LoginService } from '../_services/login.service';
import { CustomValidator } from '../_services/customValidator';
import { GlobalService } from '../_services/global.service';

@Component({
    selector: 'app-newsignup',
    templateUrl: './newsignup.component.html',
    styleUrls: ['./newsignup.component.scss'],
    standalone: false
})
export class NewsignupComponent implements OnInit {

  showSignupform: boolean = false
  invalidCode: boolean = false
  codeAlreadyUsed: boolean = false
  signupform: UntypedFormGroup;
  isOtpSent: boolean = false;
  isOtpVerified: boolean = false
  providerCode: string = '';

  otpArray: string[] = new Array(6).fill('');
  countdown: number = 60;
  timer: any;

  successMessage: string = '';
  errorMessage: string = '';


  showpassword: boolean = false
  otpLoginEmail: string = '';

  show: boolean = false;
  showConfirm: boolean = false;
  termsacceptError: boolean = false;
  confirmemailform: boolean = false
  
  constructor(private route: ActivatedRoute,
    private verificationService: VerificationService,
    public fb: UntypedFormBuilder,
    private loginService: LoginService,
    private router: Router
  ) {
    this.route.queryParams.subscribe(params => {

      const provider = params['provider'];
      this.providerCode = params['code'];
      const redirect = params['redirect'];
      const user_already_exist = GlobalService.decryptData(params['tokenau']);

      if (redirect == 'teaminvite') {
        localStorage.clear();
        if (user_already_exist == "true" || user_already_exist == true) {
          this.router.navigate(['/login']);
        } else {
          this.router.navigate(['/self-signup'], { queryParams: params })
        }
      } else if (provider !== 'appsumo') {
        this.router.navigate(['/login'], { queryParams: params });
      }

      // if (provider == 'appsumo' && this.providerCode) {
      // this.verificationService.verifyCode({ provider: provider, code: this.providerCode }).subscribe((response) => {
      //   console.log(response, 'response')
      //   if (response['status'] == 'failure' && response['message'] == 'Invalid code') {
      //     this.invalidCode = true
      //   } else if (response['status'] == 'failure' && response['message'] == 'Code already used') {
      //     this.codeAlreadyUsed = true
      //   } else if (response['status'] == 'success' && response['message'] == 'Code is valid') {
      //     this.showSignupform = true
      //   }
      // });
      // }

    });


  }


  ngOnInit() {
    this.signupform = this.fb.group({
      firstName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^[a-zA-Z]*$/i)])],
      lastName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^[a-zA-Z]*$/i)])],
      loginemail: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$'), Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      designation: ['', Validators.compose([noWhitespaceValidator, Validators.pattern(/^[a-zA-Z\s.-]*$/i)])],
      password: [null, Validators.compose([
        // Validators.pattern(this.pattern), 
        // 1. Password Field is Required
        Validators.required,
        // 2. check whether the entered password has a number
        CustomValidator.patternValidator(/\d/, { hasNumber: true }),
        // 3. check whether the entered password has upper case letter
        CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        // 4. check whether the entered password has a lower-case letter
        CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
        // 5. check whether the entered password has a special character
        CustomValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
        // 6. Has a minimum length of 8 characters
        Validators.minLength(8),
        // 7. check whether the entered password has a reserved keyword
        CustomValidator.keywordIncludes("password", { hasKeyword: true })])],
      confirmpassword: ['', Validators.required],
      companyname: ['', Validators.compose([noWhitespaceValidator, Validators.pattern(/^[a-zA-Z\s.'-]*$/i)])],
      termsaccept: [false, Validators.requiredTrue], // Apply requiredTrue validation
      otpVerified: [false, otpVerifiedValidator],
      // otp0: ['', Validators.required],
      // otp1: ['', Validators.required],
      // otp2: ['', Validators.required],
      // otp3: ['', Validators.required],
      // otp4: ['', Validators.required],
      // otp5: ['', Validators.required],
      otp: ['', Validators.required]
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
    }

    function otpVerifiedValidator(control: AbstractControl): ValidationErrors | null {
      return control.value === false ? { otpNotVerified: true } : null;
    }


    this.signupform.valueChanges.subscribe((data) => {
      if (((data && data.loginemail == '') || (this.otpLoginEmail != data.loginemail)) && this.isOtpSent == true) {
        this.isOtpSent = false;
        // this.otpArray = new Array(6).fill('');
        this.signupform.patchValue({otp: ''}); 
        this.countdown = 60;
        clearInterval(this.timer);
        this.isOtpVerified = false;
      }

      if (data.password != data.confirmpassword) {
        this.signupform['controls'].confirmpassword.setErrors({ 'invalidpwd': true })
      } else {
        this.signupform['controls'].confirmpassword.setErrors(null)
      }
      
      if(data && data.otp && data.otp.toString().length == 6) {
       this.verifyOtp();
      }

      // this.checkOtpComplete(data);
    })
  }

  checkOtpComplete(data: any): void {
    if (this.validateOtp()) {
      this.verifyOtp();
    }
  }

  validateOtp(): boolean {
    // Check if all OTP fields are filled
    for (let i = 0; i < 6; i++) {
      if (!this.signupform.get('otp' + i)?.value) {
        return false;
      }
    }
    return true;
  }

  verifyAppSumoCode() {
    console.log('verifyAppSumoCode')
  }

  sendOtp() {
    const loginemail = this.signupform.getRawValue().loginemail;

    const parameter = {
      loginemail: loginemail
    }

    if (loginemail) {
      this.otpLoginEmail = loginemail;
      this.verificationService.sendOtp(parameter).subscribe((response: any) => {
        if (response && response['status'] == 'success' && response['message'] == 'OTP sent successfully') {
          this.isOtpSent = true;
          this.successMessage = "An OTP (One-Time Password) has been sent to your email. Please check your inbox for the verification code.";
          setTimeout(() => {
            this.successMessage = '';
          }
            , 3000);

          this.startTimer();
        } else {
          this.errorMessage = "User Already Exists. Please reach out to support@webbtree.com or marketing@webbtree.com for any assistance.";
          setTimeout(() => {
            this.errorMessage = '';
          }
            , 3000);
        }
      });
    }

  }

  verifyOtp() {
    if (this.isOtpVerified == false) {
      const { loginemail, otp } = this.signupform.getRawValue();
      console.log(otp, "otp")
      if (otp && loginemail) {
        const parameter = {
          otp: otp,
          loginemail: loginemail
        }

        this.verificationService.verifyOtp(parameter).subscribe((response: any) => {
          if (response && response['status'] == 'success' && response['message'] == 'OTP verified successfully') {
            this.isOtpVerified = true
            this.signupform.patchValue({ otpVerified: true });
            this.successMessage = "OTP verified successfully.";
            setTimeout(() => {
              this.successMessage = '';
            }
              , 3000);
          } else {
            this.errorMessage = "Invalid OTP. Please try again.";
            setTimeout(() => {
              this.errorMessage = '';
            }
              , 3000);
          }
        });
      }
    }
  }


  reconfirmpwd() {
    if (this.signupform.value.password == this.signupform.value.confirmpwd) {
      return this.signupform['controls'].confirmpwd.setErrors(null)
    } else {
      return this.signupform['controls'].confirmpwd.setErrors({ 'invalidpwd': true })
    }
  }

  signUp() {
    const parameter = {
      firstname: this.signupform.getRawValue().firstName,
      lastname: this.signupform.getRawValue().lastName,
      loginemail: this.signupform.getRawValue().loginemail,
      pwd: this.signupform.getRawValue().password,
      designation: this.signupform.getRawValue().designation,
      extn: this.signupform.getRawValue().mobileno,
      company: this.signupform.getRawValue().companyname,
      registeredvia: 'app sumo',
      code: this.providerCode
    }

    this.loginService.newSignup(parameter).subscribe((response: any) => {
      if (response && response['status'] == 'success' && response['message'] == 'User created successfully') {
        this.successMessage = "Registration successful! Redirecting to login…";
        setTimeout(() => {
          this.successMessage = '';
          this.router.navigate(['/login']);
        }, 3000);
      } else if (response && response['status'] == 'failure') {
        if (response['message'] == 'Invalid code') {
          this.errorMessage = "Invalid Promo Code";
        } else if (response['message'] == 'User already exists') {
          this.errorMessage = "User Already Exists. Please reach out to support@webbtree.com or marketing@webbtree.com for any assistance";
        } else if (response['message'] == 'User email not verified') {
          this.errorMessage = "User email not verified";
        }
        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      }
    });
  }


  startTimer() {
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  retryOtp() {
    this.countdown = 60;
    // this.otpArray = new Array(6).fill('');
    this.signupform.patchValue({otp: ''});
    // this.startTimer();
    // Trigger OTP resend logic here
    this.sendOtp();
  }

  showpassworderror() {
    this.showpassword = true
  }

  focusOut() {
    this.showpassword = false
  }


  handlePaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || window['clipboardData'];
    const pastedText = clipboardData.getData('text');
    if (pastedText.length === this.otpArray.length) {
      this.otpArray = pastedText.split('');
      // Prevent the default paste behavior
      event.preventDefault();

      this.signupform.patchValue({
        otp0: this.otpArray[0],
        otp1: this.otpArray[1],
        otp2: this.otpArray[2],
        otp3: this.otpArray[3],
        otp4: this.otpArray[4],
        otp5: this.otpArray[5]
      });
    }
  }


}
